import { render, staticRenderFns } from "./new.vue?vue&type=template&id=33522b38&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./new.vue?vue&type=style&index=0&id=33522b38&prod&scoped=true&lang=css"
import style1 from "./new.vue?vue&type=style&index=1&id=33522b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33522b38",
  null
  
)

export default component.exports